import React, { useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// Custom hooks
import { useGlobal } from "@considr-it/storied-shared";
// Icons
import { ExamplesIcon, HomeIcon, DocIcon, Pricing } from "../IconsSvg";
// Styles
import {
  BottomNavBarWrapper,
  ButtonsWrapper,
  MenuItem,
  Text,
} from "./bottom-nav-bar.style";
import { usePayment } from "../../hooks/use-payment";
import { PaymentTier } from "@considr-it/storied-enums";

export const BottomNavBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isPWA, isMobile, isSmallMobile } = useGlobal();
  const { paymentInfo } = usePayment();

  const menuItems = useMemo(() => {
    const items = [
      { route: "/", icon: HomeIcon, text: "Home" },
      { route: "/documents", icon: DocIcon, text: "My Docs" },
      { route: "/whytalk", icon: ExamplesIcon, text: "Why talk?" },
    ];

    if (
      [
        PaymentTier.PAYMENT_TIER_EXPIRED,
        PaymentTier.PAYMENT_TIER_PRO_TRIAL,
      ].includes(paymentInfo.paymentTier)
    ) {
      items.push({
        route: "/pricing",
        icon: Pricing,
        text: "Pricing",
      });
    }

    return items;
  }, [paymentInfo]);

  useEffect(() => {
    if (isPWA && isMobile) {
      const app = document.querySelector(".app") as HTMLElement | null;
      app.style.paddingBottom = "88px";
    }
  }, []);

  const isRouteActive = (route: string): boolean =>
    location.pathname === route ||
    (location.pathname.startsWith(route) && route !== "/");

  const smallMobileStyles = isSmallMobile ? { width: 20, height: 20 } : {};
  return (
    <BottomNavBarWrapper id="bottom-nav-bar" $addHeight={isPWA}>
      <ButtonsWrapper>
        {menuItems.map(({ route, icon: Icon, text }) => (
          <MenuItem key={route} onClick={() => navigate(route)}>
            <Icon
              {...smallMobileStyles}
              $color={isRouteActive(route) ? "#fa8152" : "#919191"}
            />
            <Text $inactive={!isRouteActive(route)}>{text}</Text>
          </MenuItem>
        ))}
      </ButtonsWrapper>
    </BottomNavBarWrapper>
  );
};
